<div class="flex flex-col flex-grow-1 gap-4">
  <div class="flex items-center py-8 px-12 border border-radius-8 bg-color-white-900 flex-grow-1" style="justify-content: space-between;">
    <div class="flex items-center gap-4 flex-grow-1">
      <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
      <input type="text"
         [placeholder]="placeholder"
         (keyup)="onInputChange($event)"
             [value]="searchText"
         class="textInput text-base font-normal"
         style="width: 100%; border: none;"
       />
    </div>
    <mat-icon (click)="searchText.length > 0 && clearSearch()" 
              [style.opacity]="searchText.length === 0 ? '0.5' : '1'"
              [style.cursor]="searchText.length === 0 ? 'default' : 'pointer'">close</mat-icon>
  </div>


  <div class="flex justify-between items-center" *ngIf="required || maxLength">
    <div>
      <div class="text-xs color-error-600" *ngIf="inputControl.hasError('required')">
        This field is required
      </div>
      <div class="text-xs color-error-600" *ngIf="inputControl.hasError('maxlength')">
        You've reached the character limit
      </div>
    </div>
    <div class="text-xs color-black-400" *ngIf="maxLength">
      {{ searchText?.length || 0 }}/{{ maxLength }}
    </div>
  </div>
</div>
